(function feeloriJadauVideoModule(root, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
    return;
  }

  root.FeelOriJadauVideoTest = api;
  api.start(root);
})(typeof window !== 'undefined' ? window : globalThis, function createFeelOriJadauVideoTest() {
  'use strict';

  const GA4_DESTINATION = 'G-QW7V2C0S90';
  const SHOPIFY_EVENT = 'feelori:jadau_video_open';
  const GA4_EVENT = 'jadau_video_open';
  const VIDEO_ID = '14gkzKgHV9M';
  const EMBED_ORIGIN = 'https://www.youtube-nocookie.com';

  function buildPayload(runtime, container) {
    return {
      placement: container.dataset.videoPlacement || 'unknown',
      video_id: container.dataset.videoId || '',
      page_path: runtime.location?.pathname || '',
      content_type: 'jadau_kundan_collection_tour',
    };
  }

  function publish(runtime, payload) {
    let published = false;

    if (typeof runtime.Shopify?.analytics?.publish === 'function') {
      try {
        const result = runtime.Shopify.analytics.publish(SHOPIFY_EVENT, payload);
        if (result && typeof result.catch === 'function') result.catch(() => {});
        published = true;
      } catch {
        // GA4 remains an independent fallback if Shopify rejects the custom event.
      }
    }

    if (typeof runtime.gtag === 'function') {
      const eventPayload = {
        ...payload,
        send_to: GA4_DESTINATION,
      };
      if (runtime.Shopify?.theme?.role === 'unpublished') eventPayload.debug_mode = true;

      try {
        runtime.gtag('event', GA4_EVENT, eventPayload);
        published = true;
      } catch {
        // Video playback must remain available when analytics is unavailable.
      }
    }

    return published;
  }

  function createIframe(runtime, container) {
    const embedUrl = new URL(container.dataset.embedUrl, EMBED_ORIGIN);
    if (embedUrl.origin !== EMBED_ORIGIN || embedUrl.pathname !== `/embed/${VIDEO_ID}`) {
      throw new Error('Unexpected Jadau video embed URL.');
    }
    const iframe = runtime.document.createElement('iframe');
    iframe.className = 'feelori-jadau-video-test__iframe';
    iframe.src = embedUrl.toString();
    iframe.title = container.dataset.videoTitle || 'FeelOri Jadau Kundan collection tour';
    iframe.loading = 'eager';
    iframe.tabIndex = 0;
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('allowfullscreen', '');
    return iframe;
  }

  function createController(runtime) {
    return {
      activate(target) {
        if (!target || typeof target.closest !== 'function') return 'ignored';

        const trigger = target.closest('[data-jadau-video-trigger]');
        if (!trigger) return 'ignored';

        const container = trigger.closest('[data-jadau-video-test]');
        if (!container || container.dataset.videoActivated === 'true') return 'ignored';

        const media = trigger.closest('.feelori-jadau-video-test__media');
        if (!media) return 'ignored';

        const shouldMoveFocus = runtime.document.activeElement === trigger;
        const iframe = createIframe(runtime, container);
        container.dataset.videoActivated = 'true';
        publish(runtime, buildPayload(runtime, container));
        media.replaceChildren(iframe);
        if (shouldMoveFocus && typeof iframe.focus === 'function') iframe.focus();
        return 'activated';
      },
    };
  }

  function start(runtime) {
    if (!runtime?.document) return 'no-document';
    if (runtime.__feeloriJadauVideoController) return 'already-started';

    const controller = createController(runtime);
    runtime.__feeloriJadauVideoController = controller;
    runtime.document.addEventListener('click', (event) => controller.activate(event.target), true);
    return 'started';
  }

  return {
    GA4_DESTINATION,
    GA4_EVENT,
    SHOPIFY_EVENT,
    VIDEO_ID,
    buildPayload,
    createController,
    createIframe,
    publish,
    start,
  };
});
